export default function($) {
  $(document).ready(function(){
    if ($('#js-galaxy-details-trigger').length) {

    	var galaxy_details = $('#js-galaxy-details');

      $('#js-galaxy-details-trigger, .dashicons-no-alt').click( function(event) {
        event.preventDefault();

        galaxy_details.slideToggle();
        $('.header-links').toggleClass('open');
      });
    }
  });
}
